import React from 'react';

const PrivateContext = React.createContext();

export default PrivateContext;